import { RootDispatch } from "redux/rootReducer";
import { load, loadFail, loadSuccess } from "./portfolioInformationActions";
import * as request from "utility/request";
import { PortfolioInformation } from "types/PortfolioInformation";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadPorfolioInformation = (reportControlId: string, reportDate: string) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load());

    try {
      const res = await request.getResponseJson<PortfolioInformation>(
        `${apiUrl}/api/portfolioInformation?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );

      dispatch(loadSuccess(res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail(error));
    }
  };
};
